import { React } from "../deps/remix.ts";
import { useBindings } from "~/hooks/use-bindings.ts";

export function PromoBlock() {
  const { promotionData } = useBindings();
  if (!promotionData || "invalidPromoCode" in promotionData) return;

  return (
    <div className="PromoBlock">
      {promotionData.description ? promotionData.description : "Promotion code found"}.{" "}
      Discount applied at checkout.
    </div>
  );
}
